<template>
  <div class="main">
    <tab title="加油卡列表"></tab>
    <div class="select_box">
      <van-search
        v-model="value"
        placeholder="请输入卡号或姓名搜索"
        input-align="center"
        @input="getCustCardList"
      />
    </div>
    <!-- <div class="chooseTime">
      <div class="choose_box" @click="show=true">
        <div class="choose_left">当前日期：{{time}}</div>
        <div class="choose_right">总金额：1639.00元</div>
      </div>
      
    </div> -->
    <div class="card_list">
      <div v-for="item in list" v-bind:key="item.id" class="card">
        <div class="cardNo" style="position: relative;">卡号：{{item.cardNo}}
          <div class="upd_btn" @click="toupdcard(item)">
            编辑
          </div>
        </div>
        <div class="oli">持卡人：{{item.custName}}</div>
        <div class="oli">余额：{{item.balance}}</div>
        <div class="oli">状态：<span :class="item.status==1?'lv':'red'">{{item.status==1?'启用':'禁用'}}</span></div>
        <div class="btn_box">
          <!-- <div class="operation_btn" v-if="item.status==1" @click="determineType(item.status,item.id)">禁用</div>
          <div class="operation_btn" v-if="item.status==0" id="lv" @click="determineType(item.status,item.id)">启用</div> -->
          <div class="info_btn" @click="showPassWord(item)">查看密码</div>
          <div class="info_btn" @click="toRecord(item)">查看流水</div>
          <div class="info_btn" @click="toDetail(item)">操作</div>
        </div>
      </div>
      <!-- <div class="card">
        <div class="cardNo">卡号：700001</div>
        <div class="oli">持卡人：张三</div>
        <div class="oli">余额：300.00</div>
        <div class="oli">状态：<span class="red">禁用</span></div>
        <div class="btn_box">
          <div class="operation_btn" @click="determineType(0)" id="lv">
            启用
          </div>
          <div class="info_btn" @click="toDetail(1)">操作</div>
        </div>
      </div> -->
    </div>
    <van-popup v-model="show" :round="true" :overlay-class="popupClass">
      <div class="timeChoose">
        <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm = "confirm"
      />
      </div>
      
    </van-popup>
  </div>
</template>

<script>
import tab from "@/components/NavBar";
import Vue from "vue";
import { Search } from "vant";
import { Button } from "vant";
import { Dialog } from "vant";
import { Toast } from 'vant';
import { Popup } from 'vant';
import { DatetimePicker } from 'vant';

Vue.use(DatetimePicker);

Vue.use(Popup);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Search);
export default {
  name: "margin",
  data() {
    return {
        value:'',
        list:[],
        show: false,
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2025, 10, 1),
        currentDate: new Date(),
        time:'',
        popupClass:'popupClass'
    };
  },
  components: {
    tab,
  },
  mounted() {
    this.confirm(this.currentDate)
    this.getCustCardList('')
  },
  methods: {
    confirm(val){
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      let hour = val.getHours()
      let minute = val.getMinutes()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
      if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
      this.time = `${year}-${month}`
      this.show = false
      // console.log(this.currentDate)
      return `${year}-${month}`
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    getCustCardList(value){
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      if(value-0>1){
        var data = {
          cardNo:value
        }
      }else{
        var data = {
          custName:value
        }
      }
      data.token = this.$storage.get('token')
      
      this.$api.post('orgapp/getCustCardList',data,response=>{
        if (response.status >= 200 && response.status < 300) {
          Toast.clear();
          console.log(response.data)
          var data = response.data
          if(data.msg=='success'){
            var list = response.data.list;
            list.forEach(element => {
              element.balance = (element.balance/100).toFixed(2)
              element.perAmount = (element.perAmount/100).toFixed(2)
            });
            this.list = list
          }
        }else{
          Toast.clear();
          Toast.fail(response.status);
        }

      })
    },
    showPassWord(item){
      Dialog.confirm({
        title: "温馨提示",
        message: `密码：${item.password}`,
        showCancelButton:false
      })
    },
    toupdcard(item){
      this.$router.push({
        name:'updCard_info',
        params:{item:item}
      })
    },
    toRecord(item){
      this.$router.push({
        name:'cardComeon_record',
        params:{item:item}
      })
    },
    toDetail(item) {
      console.log(item);
      if(item.share==1){
        Dialog.confirm({
          title: "温馨提示",
          message: '共享账户不可对卡进行分配操作',
          showCancelButton:false
        })
        return
      }
      // this.$router.push({
      //   name: "jiayou_operation",
      //   query: { ykid: toString(item), nav_name: "加油卡操作" },
      // });
      this.$router.push({
        name: "jiayou_operation",
        params: { item:item, nav_name: "加油卡操作" },
      });
    },
    determineType(type,id) {
      if (type == 1) {
        //当前状态为启用，点击后执行停用
        //调用接口停用
        var msg = "确认禁用该加油卡？";
        var status=0
      }
      if (type == 0) {
        //当前状态为停用，点击后执行启用
        //调用接口启用
        var msg = "确认启用该加油卡？";
        var status=1
      }
      Dialog.confirm({
        title: "标题",
        message: msg,
      })
        .then(() => {
          // on confirm
           this.enableCustCard(id,status)
        })
        .catch(() => {
          // on cancel
        });
    },
    enableCustCard(id,status){
      var data = {
        id:id,
        status:status,
        token:this.$storage.get('token')
      }
      this.$api.post('orgapp/enableCustCard',data,response=>{
        if(response.status>=200&& response.status < 300){
          console.log(response.data)
          var data = response.data
          if(data.msg=='success'){
              Toast.success('更改成功！');
              this.value =''
              this.getCustCardList('')
          }
        }
      })
    }
  },
};
</script>

<style scoped>
.main {
  background-color: #F7F8FA;
  height: 100vh;
}
.select_box {
  width: 100%;
  background-color: #fff;
  text-align: center;
}
.card_list {
  width: 93%;
  margin: auto;
}
.card {
  margin-top: 10px;
  width: 100%;
  height: 128px;
  background-color: #fff;
  position: relative;
  color: #000;
  border-radius: 6px;
  font-family: 'SimSun';
}
.cardNo {
  border-bottom: 1px solid #eee;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  font-size: 14px;
}
.oli {
  padding-left: 10px;
  height: 25px;
  width: 36%;
  line-height: 25px;
  display: inline-block;
}
.lv {
  color: chartreuse;
}
.red {
  color: #fb0606;
}
.btn_box {
  position: absolute;
  right: 0;
  bottom: 5px;
}
.operation_btn {
  width: 62px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: #ee0a24;
  display: inline-block;
  margin-right: 5px;
}
.upd_btn {
  position: absolute;
  right: 0;
  bottom: 1.5px;
  width: 62px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 4px;
  background-color: #1989fa;
  display: inline-block;
  margin-right: 5px;
  color: #fff;
}
.info_btn {
  width: 62px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 4px;
  background-color: #1989fa;
  display: inline-block;
  margin-right: 5px;
  color: #fff;
}
#lv {
  background-color: #07c160;
}
.popupClass {
  
}
.timeChoose {
  width: 300px;
}
.chooseTime {
  width: 100%;
  height: 30px;
  line-height: 30px;
  background-color: #fff;
  font-size: 12px;
}
.choose_box {
  width: 93%;
  margin: auto;
}
.choose_left {
  float: left;
}
.choose_right{
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/jiayou_card.vue